import { WifiOff } from 'lucide-react'
import { useOnline } from '@/hooks/useOnline'

/**
 * Passive top-of-app banner that surfaces when the browser reports
 * offline. Renders nothing while online so it costs zero pixels in the
 * happy path. Pairs with useAsyncRetry — when the user clicks Retry on
 * an ErrorState block while offline, this banner explains why.
 */
export default function OfflineBanner() {
  const online = useOnline()
  if (online) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-[60] bg-amber-900/95 backdrop-blur-sm border-b border-amber-700/40 text-amber-50"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium">
        <WifiOff className="w-4 h-4 shrink-0" aria-hidden="true" />
        <span>You're offline. Reconnect to keep going — we'll resume automatically.</span>
      </div>
    </div>
  )
}
